import { filterClasses } from "@swivl-mono/helpers";
import { ReactNode } from "react";

import { InputSize } from "./Input";

interface InputSuffixProps {
  children: ReactNode;
  className?: string;
  inputSize?: InputSize;
  onClick?: () => void;
  disabled?: boolean;
}

export function InputSuffix({ children, inputSize = InputSize.MEDIUM, onClick, disabled, className }: InputSuffixProps) {
  const sizes = {
    [InputSize.SMALL]: "h-[26px] px-2 text-sm",
    [InputSize.MEDIUM]: "h-[34px] pr-3 pl-2"
  };

  return (
    <button
      type="button"
      onClick={onClick}
      disabled={disabled}
      className={filterClasses(
        className,
        "absolute top-0 right-0 flex items-center justify-center",
        disabled ? "text-grey-500" : "text-grey-600",
        sizes[inputSize],
        onClick && !disabled && "pointer-events-auto cursor-pointer hover:text-orange-500",
        (!onClick || disabled) && "pointer-events-none",
        "transition-colors duration-150 ease-in-out"
      )}
    >
      {children}
    </button>
  );
}
